<div
  class="booking-widget-root flex flex--column relative white-bg pr-medium rounded-large"
  [class.compact]="compactMode"
  data-test-booking-widget-root
  #widgetRoot
  [@smoothGrow]="{ value: showCompact$ | async, params: { startHeight: (rootContainerStartHeight$ | async) + 'px' } }"
  (click)="startHotjarCapture()"
>
  <h1 *ngIf="headingLevel === 1" class="nordic-blue-900-text font-heading-2" data-test-booking-widget-title>
    {{ 'bookingSearch.title' | finLocalization }}
  </h1>
  <h2 *ngIf="headingLevel === 2" class="nordic-blue-900-text font-heading-2" data-test-booking-widget-title>
    {{ 'bookingSearch.title' | finLocalization }}
  </h2>

  <fcom-tabs
    class="ps-medium-t"
    [theme]="TabTheme.DEFAULT"
    [bottomBorder]="false"
    [whiteSpaceNowrap]="true"
    (clickedTab)="setActiveTab($event)"
    [prevButtonAriaLabel]="'carousel.previous' | finLocalization"
    [nextButtonAriaLabel]="'carousel.next' | finLocalization"
    data-test-booking-widget-tabs
  >
    <!-- flight -->
    <fcom-tab
      [title]="'bookingWidgetTabs.flight' | finLocalization"
      [attr.data-test-booking-widget-tab]="WidgetTab.FLIGHT"
      [active]="(activeTab$ | async) === WidgetTab.FLIGHT"
    >
      <ng-container *ngTemplateOutlet="flightSearchGrid; context: { tripType: (tripType$ | async) }"></ng-container>
    </fcom-tab>

    <!-- award -->
    <fcom-tab
      [title]="'bookingWidgetTabs.award' | finLocalization"
      [attr.data-test-booking-widget-tab]="WidgetTab.AWARD"
      [active]="(activeTab$ | async) === WidgetTab.AWARD"
    >
      <ng-container [ngSwitch]="loginStatus$ | async">
        <fin-login-card
          *ngSwitchCase="LoginStatus.NOT_LOGGED_IN"
          [benefitMode]="'text'"
          [benefitText]="'award.login.description'"
          [title]="'award.login.title'"
        ></fin-login-card>
        <fcom-loader
          *ngSwitchCase="LoginStatus.PENDING"
          [loaderType]="LoaderTheme.EMBEDDED"
          [title]="'loader.title'"
          data-test-award-tab-loader
        ></fcom-loader>
        <ng-container *ngSwitchCase="LoginStatus.LOGGED_IN">
          <ng-container *ngTemplateOutlet="flightSearchGrid; context: { tripType: (tripType$ | async) }"></ng-container>
        </ng-container>
      </ng-container>
    </fcom-tab>

    <!-- flightPlusHotel -->
    <fcom-tab
      [title]="'bookingWidgetTabs.flightAndHotel' | finLocalization"
      [attr.data-test-booking-widget-tab]="WidgetTab.AM"
      [active]="(activeTab$ | async) === WidgetTab.AM"
      *ngIf="amTabEnabled$ | async"
    >
      <fin-am-booking-widget
        *ngIf="initAm$ | async"
        (setLocations)="onAmLocationChanged()"
        data-test-am-booking-widget
      ></fin-am-booking-widget>
    </fcom-tab>
  </fcom-tabs>

  <!-- Price matrix / airCalendar modal -->
  <fin-air-calendar
    *ngIf="airCalendarPrices$ | async"
    [paxAmount$]="paxAmount$"
    [travelDates$]="travelDates$"
    [tripType$]="tripType$"
    [prices$]="airCalendarPrices$"
    [isAward]="(activeTab$ | async) === WidgetTab.AWARD"
    [totalPoints]="(profile$ | async)?.awardPoints"
    (selectDates)="setTravelDates($event, true)"
    (continue)="navigateToBookingFlow(true, $event)"
  ></fin-air-calendar>
</div>

<ng-template #flightSearchGrid let-tripType="tripType">
  <!-- Compact grid -->
  <ng-container *ngIf="(showCompact$ | async) && tripType !== TripType.MULTICITY">
    <div class="selector-grid compact grid-col-12 no-gutters" data-test-widget-selector-grid>
      <div class="md-col-1-4 col-1-12">
        <fin-trip-type-selector
          [selectedTripType$]="tripType$"
          [availableTripTypes$]="availableTripTypes$"
          (setTripType)="setTripType($event)"
        ></fin-trip-type-selector>
      </div>
      <div class="md-col-5-12 col-1-12">
        <fin-location-selector
          [locationPair$]="locations$"
          [suggestedLocations$]="suggestedLocations$"
          [trendingDestinations$]="trendingDestinations$"
          [showPreviousSearches]="true"
          (setLocations)="updateLocations($event)"
        ></fin-location-selector>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="(showCompact$ | async) === false || tripType === TripType.MULTICITY">
    <!-- Traditional booking grid -->
    <ng-container *ngIf="tripType !== TripType.MULTICITY">
      <div class="selector-grid grid-col-12 no-gutters" data-test-widget-selector-grid>
        <div class="md-col-1-4 col-1-12">
          <fin-trip-type-selector
            [selectedTripType$]="tripType$"
            [availableTripTypes$]="availableTripTypes$"
            (setTripType)="setTripType($event)"
          ></fin-trip-type-selector>
        </div>
        <div class="md-col-5-12 col-1-12">
          <fin-location-selector
            [locationPair$]="locations$"
            [suggestedLocations$]="suggestedLocations$"
            [trendingDestinations$]="trendingDestinations$"
            [showPreviousSearches]="true"
            (setLocations)="updateLocations($event)"
          ></fin-location-selector>
        </div>

        <div class="md-col-1-4 col-1-12">
          <fin-pax-amount-selector
            [travelClass$]="travelClass$"
            [availableTravelClasses$]="availableTravelClasses$"
            [paxAmount$]="paxAmount$"
            (setTravelClass)="setTravelClass($event)"
            (setPaxAmount)="setPaxAmount($event)"
          ></fin-pax-amount-selector>
        </div>
        <div class="md-col-5-12 col-1-12">
          <fin-travel-dates-selector
            [travelDates$]="travelDates$"
            [isOneway$]="tripType === TripType.ONEWAY | finToObservable"
            [prices$]="prices$"
            (setTravelDates)="setTravelDates($event)"
            (setFlexibleDates)="flexibleDates$.next($event)"
          ></fin-travel-dates-selector>
        </div>

        <ng-container *ngTemplateOutlet="widgetFooter"></ng-container>
      </div>
    </ng-container>

    <!-- Multicity booking grid -->
    <ng-container *ngIf="tripType === TripType.MULTICITY">
      <div class="selector-grid multicity-single grid-col-12 no-gutters">
        <div class="md-col-1-4 col-1-12">
          <fin-trip-type-selector
            [selectedTripType$]="tripType$"
            [availableTripTypes$]="availableTripTypes$"
            (setTripType)="setTripType($event)"
          ></fin-trip-type-selector>
        </div>
        <div class="md-col-5-12 col-1-12">
          <fin-pax-amount-selector
            [travelClass$]="travelClass$"
            [availableTravelClasses$]="availableTravelClasses$"
            [paxAmount$]="paxAmount$"
            (setTravelClass)="setTravelClass($event)"
            (setPaxAmount)="setPaxAmount($event)"
          ></fin-pax-amount-selector>
        </div>
      </div>
      <ng-container *ngIf="multiCityLocations$ | finObsToArray as multiCityLocations">
        <ng-container *ngFor="let locationPair$ of multiCityLocations; index as i; first as first; last as last">
          <h2 class="font-body-1">{{ 'bookingSearch.' + (first ? 'departure' : 'return') | finLocalization }}</h2>
          <div class="selector-grid multicity-double grid-col-12 no-gutters ps-xsmall-t ps-medium-b">
            <div class="md-col-1-8 col-1-12">
              <fin-location-selector
                [locationPair$]="locationPair$"
                [suggestedLocations$]="first ? suggestedLocations$ : (undefined | finToObservable)"
                [trendingDestinations$]="first ? trendingDestinations$ : (undefined | finToObservable)"
                [originDisabled]="!first && (multiCityLocations[i - 1] | async).destination === undefined"
                [destinationDisabled]="last && (multiCityLocations[0] | async).origin === undefined"
                [allowedOriginContinent]="
                  !first ? (multiCityLocations[i - 1] | async)?.destination?.continentCode : undefined
                "
                [allowedDestinationContinent]="
                  last ? (multiCityLocations[0] | async)?.origin?.continentCode : undefined
                "
                [showSeparator]="false"
                [showLocateMe]="first"
                (setLocations)="updateLocationPair($event, i)"
                data-test-multicity-location-selector
              ></fin-location-selector>
            </div>
            <div class="md-col-9-12 col-1-12">
              <fin-travel-dates-selector
                [travelDates$]="travelDates$"
                [showSingular]="first ? 'departureDate' : 'returnDate'"
                [showSeparator]="false"
                (setTravelDates)="setTravelDates($event)"
                (setFlexibleDates)="flexibleDates$.next($event)"
                data-test-multicity-travel-dates-selector
              ></fin-travel-dates-selector>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngTemplateOutlet="widgetFooter"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #widgetFooter>
  <div class="col-1-12">
    <div *ngIf="(activeTab$ | async) === WidgetTab.FLIGHT">
      <fin-discount-code></fin-discount-code>
    </div>

    <div
      *ngIf="
        (activeTab$ | async) !== WidgetTab.AWARD ||
        ((activeTab$ | async) === WidgetTab.AWARD && (loginStatus$ | async) === LoginStatus.LOGGED_IN)
      "
      class="flex ps-medium-t"
      [ngClass]="{ 'flex--space-between flex--middle': (activeTab$ | async) === WidgetTab.FLIGHT }"
      [class.flex--end]="(activeTab$ | async) !== WidgetTab.FLIGHT"
      data-test-booking-widget-footer
    >
      <div *ngIf="(activeTab$ | async) === WidgetTab.FLIGHT" data-test-booking-widget-footer-price>
        <div class="font-body-1 regular-type">
          {{
            ((tripType$ | async) === TripType.ONEWAY
              ? 'bookingWidget.priceCalendar.oneWayPerAdult'
              : 'bookingWidget.priceCalendar.roundTripPerAdult'
            ) | finLocalization
          }}
        </div>
        <div class="nordic-900-text bold-type font-heading-4">
          {{ startingPrice$ | async | finPrice: { stripZeroCents: true, useSymbol: true } | finEmpty: '&ndash;' }}
        </div>
      </div>
      <fcom-button
        class="continue-btn"
        [theme]="ButtonTheme.PRIMARY_HEATHER"
        [size]="ButtonSize.R_LARGE"
        [mode]="ButtonMode.FILL"
        [loading]="loading$ | async"
        [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
        [text]="'bookingSearch.search' | finLocalization"
        [disabled]="(continueEnabled$ | async) === false"
        (click)="navigateToBookingFlow()"
        data-test-widget-continue-button
      ></fcom-button>
    </div>
    <fin-booking-widget-notifications
      [locations$]="locations$"
      [tripType$]="tripType$"
    ></fin-booking-widget-notifications>
  </div>
</ng-template>
